import { ProfileForm } from "../components/profile-form";
import Header from "modules/main/components/header";
import SettingsLayout from "../components/layout";
import { BuyingSettings } from "modules/users/components/buying-settings";
import { useMediaQuery } from "@/hooks/use-media-query";
import { isDesktopSize } from "utils/is-desktop";
import { OrdersHistory } from "../components/orders";
import { useState, useEffect } from "react";
import { usePageTitle } from "hooks/usePageTitle";

type section = "account" | "preferences" | "history" | "notifications";
interface SettingsPageProps {
    section?: section;
}




export const SettingsPage:React.FC<SettingsPageProps> = ({section}) => {
    const { setTitle } = usePageTitle();
    const sectionMap: Record<section, React.ComponentType> = {
    account: ProfileForm,
    preferences: (props) => <BuyingSettings {...props} update={true}/>,
    history: () => <OrdersHistory setOpenCartSheet={setOpenCartSheet} />,
    notifications: () => <div>Notificaciones</div>,
}


    const isDesktop = useMediaQuery(isDesktopSize);
    const [openCartSheet,setOpenCartSheet] = useState(false);
    const SectionComponent = (section)?sectionMap[section]:(isDesktop)?ProfileForm:null;

    useEffect(() => {
        if (!section || section === "account") {
            setTitle("Cuenta");
        } else if (section === "preferences") {
            setTitle("Preferencias");
        }
    }, [section, setTitle]);

    return (
    <>
        <SettingsLayout>            
                {SectionComponent?(<SectionComponent />):(null)}                          
        </SettingsLayout>        
    </>    
    );
};
